import * as React from "react";
import UserSupport from "./customer-support/UserSupport";
import TeamSupport from "./customer-support/TeamSupport";
import Team from "./commons/model/Team";
import ImpersonateAction from "./commons/model/ImpersonateAction";
import Country from "./commons/model/address/Country";
import { createRoot } from "react-dom/client";

interface CustomerSupportProps {
  countries: Country[];
  teams: Team[];
  impersonateAction: ImpersonateAction;
  profileUrl: string;
  inviteEndpoint?: string;
}

interface CustomerSupportState {
  selectedTeam?: Team;
}

export default class CustomerSupport extends React.Component<
  CustomerSupportProps,
  CustomerSupportState
> {
  constructor(props: CustomerSupportProps) {
    super(props);
    this.state = {
      selectedTeam: undefined,
    };
  }

  render() {
    const teams = this.props.teams;
    return (
      <>
        <TeamSupport
          countries={this.props.countries}
          teams={this.props.teams}
          onTeamSelected={(team: Team) => this.setState({ selectedTeam: team })}
        />
        {teams.length > 0 && (
          <UserSupport
            teams={this.props.teams}
            selectedTeam={this.state.selectedTeam}
            impersonateAction={this.props.impersonateAction}
            profileUrl={this.props.profileUrl}
            inviteEndpoint={this.props.inviteEndpoint}
          />
        )}
      </>
    );
  }

  static loadComponent(elementId: string, props: CustomerSupportProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<CustomerSupport {...props} />);
  }
}
